import React from "react";
import PropTypes from "prop-types";

const apiTranslations = [
  { icon: "clear-day", bg: "Sunny" },
  { icon: "clear-night", bg: "Night" },
  { icon: "rain", bg: "Rainy" },
  { icon: "snow", bg: "Snowy" },
  { icon: "sleet", bg: "Snowy" },
  { icon: "wind", bg: "Cloudy" },
  { icon: "fog", bg: "Cloudy" },
  { icon: "cloudy", bg: "Cloudy" },
  { icon: "partly-cloudy-day", bg: "Cloudy" },
  { icon: "partly-cloudy-night", bg: "Cloudy-Night" },
  { icon: "hail", bg: "Stormy" },
  { icon: "thunderstorm", bg: "Stormy" },
  { icon: "tornado", bg: "Stormy" },
];

const WeatherBackground = ({ icon }) => {
  const i = apiTranslations.find((e) => e.icon === icon);
  const bgStyle = !icon
    ? null
    : {
        backgroundImage: `url('/img/schools/weather/${i.bg}.jpg')`,
      };
  return <div className="content-background" style={bgStyle} />;
};
WeatherBackground.propTypes = {
  icon: PropTypes.string,
};

WeatherBackground.defaltProps = {
  icon: "clear-day",
};

export default WeatherBackground;



// WEBPACK FOOTER //
// ./resources/assets/js/app/SchoolProfileView/WeatherBackground.js